import React from 'react';

export const FREE_STANDARD_THRESHOLD = 100;
export const FREE_TWO_DAY_THRESHOLD = 175;

/**
 * Two-stage free-shipping progress bar:
 *  - Below $100: bar fills toward Free Standard Shipping
 *  - $100-$175: bar fills toward Free 2-Day Shipping (with a marker for Standard)
 *  - $175+: full bar, "you qualified" message
 */
export default function FreeShippingProgress({ subtotal, hidden = false }) {
  if (hidden) return null;
  const sub = Math.max(0, subtotal || 0);
  let pct;
  let message;
  if (sub < FREE_STANDARD_THRESHOLD) {
    pct = (sub / FREE_TWO_DAY_THRESHOLD) * 100;
    const remaining = FREE_STANDARD_THRESHOLD - sub;
    message = (
      <>Add <strong className="text-foreground">${remaining.toFixed(2)}</strong> more for <strong className="text-foreground">FREE Standard Shipping</strong></>
    );
  } else if (sub < FREE_TWO_DAY_THRESHOLD) {
    pct = (sub / FREE_TWO_DAY_THRESHOLD) * 100;
    const remaining = FREE_TWO_DAY_THRESHOLD - sub;
    message = (
      <><span className="text-green-600 font-medium">✓ Free Standard Shipping unlocked.</span> Add <strong className="text-foreground">${remaining.toFixed(2)}</strong> more for <strong className="text-foreground">FREE 2-Day Shipping</strong></>
    );
  } else {
    pct = 100;
    message = <span className="text-green-600 font-medium">✓ Free 2-Day Shipping unlocked!</span>;
  }
  // Position of the "Free Standard" milestone on the bar
  const standardMarkerPct = (FREE_STANDARD_THRESHOLD / FREE_TWO_DAY_THRESHOLD) * 100;

  return (
    <div className="space-y-1.5" data-testid="free-shipping-progress">
      <p className="text-xs text-muted-foreground font-body">{message}</p>
      <div className="relative h-2 w-full rounded-full bg-muted overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 bg-[hsl(210,45%,40%)] transition-all duration-500"
          style={{ width: `${Math.min(100, Math.max(0, pct))}%` }}
        />
        {/* Milestone marker for Free Standard at the $100 mark */}
        <div
          className="absolute inset-y-0 w-px bg-foreground/40"
          style={{ left: `${standardMarkerPct}%` }}
          aria-hidden="true"
        />
      </div>
      <div className="flex justify-between text-[10px] text-muted-foreground font-body">
        <span>$0</span>
        <span>${FREE_STANDARD_THRESHOLD} Free Standard</span>
        <span>${FREE_TWO_DAY_THRESHOLD} Free 2-Day</span>
      </div>
    </div>
  );
}
